import { useQuery } from '@tanstack/react-query';
import { listQueryDefaults } from '../../../lib/query/listQuery';
import { getOfferings } from '../api/offerings';
import type { GetOfferingsParams } from '../types';

export function useOfferings(params: GetOfferingsParams = {}) {
  return useQuery({
    queryKey: ['offerings', params],
    queryFn: () => getOfferings(params),
    ...listQueryDefaults,
  });
}
